/**
 * Qikify upsell thumbnails at card size.
 *
 * The app asks Shopify for its product images at 100x100, and the file behind
 * that is 80x100 — soft on any retina screen even at the 88px thumbnail the
 * cards use. Shopify's CDN takes the dimensions from the filename, so this
 * rewrites the size suffix on the inline background-image the app sets. 300px
 * covers the thumbnail at 3x without pulling a card-sized file down.
 *
 * The app re-renders its own list, so a MutationObserver re-applies the swap.
 * It only touches URLs that already carry a size suffix, and skips ones it has
 * already rewritten, so running it repeatedly costs nothing.
 */
(() => {
  const TARGET_SIZE = '_300x300';
  const SIZE_SUFFIX = /_(\d+)x(\d+)(\.[a-z]+)/i;

  const upgrade = (el) => {
    const current = el.style.backgroundImage;
    if (!current || current.includes(TARGET_SIZE)) return;
    const upgraded = current.replace(SIZE_SUFFIX, `${TARGET_SIZE}$3`);
    if (upgraded !== current) el.style.backgroundImage = upgraded;
  };

  const upgradeWithin = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches('.qbk-offer__image')) upgrade(node);
    node.querySelectorAll('.qbk-offer__image').forEach(upgrade);
  };

  /*
   * Attributes as well as added nodes. Ticking an offer or changing its variant
   * makes the app rewrite the style attribute on the very same element — the
   * node is never replaced — so watching childList alone let the URL fall back
   * to 100x100 the moment anyone touched a card. upgrade() is idempotent, so
   * the write this observer triggers is not seen as another change to act on.
   */
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') upgradeWithin(record.target);
      else record.addedNodes.forEach(upgradeWithin);
    }
  });

  /* Scoped to the app's mount points, which the section renders server-side, so
     the page's other style changes don't wake this up. */
  const mounts = document.querySelectorAll('[id^="qbk-bogo-offer-"]');
  const roots = mounts.length ? mounts : [document.body];

  roots.forEach((root) => {
    upgradeWithin(root);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  });
})();
